import React from "react";
import "./Header.css";
import {Fade} from "react-reveal";
import {greeting} from "../../portfolio";

function Header(vinay, guda) {
  return (
    <Fade top duration={1000} distance="20px">
    <div>
      <header className="header">
        <a href="" className="logo">
          <span className="grey-color">(</span>
          <span className="logo-name">{greeting.firstName}</span>,
          <span className="logo-name">{greeting.lastName}</span>
          <span className="grey-color">) = &gt; &#123; </span>
        </a>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label className="menu-icon" htmlFor="menu-btn">
          <span className="navicon"></span>
        </label>
        <ul className="menu">
          <li>
            <a href="#skills">Skills</a>
          </li>
            <li>
              <a href="#experience">Work Experiences</a>
            </li>
          <li>
            <a href="#featured-projects">Featured Projects</a>
          </li>
          <li>
            <a href="#certifications">Certifications</a>
          </li>
           <li>
            <a href="#education">Education</a>
          </li>
          <li>
            <a href="#contact">Contact Me</a>
          </li>
        </ul>
        <span className="grey-color logo"> &#125; </span>
      </header>
    </div>
    </Fade>
  );
}
export default Header;
